const styles = (theme) => ({
  avatar: {
    height: 45,
    width: 45,
    backgroundColor: '#E3E9EC',
    color: '#235078',
    marginLeft: theme.spacing(1),
  },
  popover: {
    width: 200,
  },
})

export default styles
